export default __webpack_public_path__ + "static/media/define5.33a1d155.png";